<div class="container" fxLayout="row" fxLayout.lt-md="column">
    <div *ngIf="!selectedCategory" class="categories-overview" fxFlex="100">
        <!-- Header Section -->
        <div class="categories-header" fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="16px">
            <div fxLayout="column">
                <h1 class="page-title">Style Categories</h1>
                <p class="page-subtitle">Organize and manage your styling categories and themes</p>
            </div>
            <div fxLayout="row" fxLayoutGap="12px" fxLayoutAlign="end center">
                <!-- Search Bar -->
                <mat-form-field appearance="outline" class="search-field">
                    <mat-label>Search categories</mat-label>
                    <input matInput [(ngModel)]="searchTerm" (ngModelChange)="onSearchChange()" placeholder="Find categories...">
                    <mat-icon matSuffix>search</mat-icon>
                </mat-form-field>
                <!-- Add Category Button -->
                <button [@cardAnimator]="animateAddCategory"
                    (@cardAnimator.done)="resetAddCategoryAnimationState()"
                    [matTooltip]="(dataSource.data?.length > 0 ? 'Add Category' : 'Add Category to get started!')"
                    mat-raised-button color="primary" (click)="addStyleCategory()" class="add-button">
                    <mat-icon>add</mat-icon> Add Category
                </button>
            </div>
        </div>

        <!-- Empty State -->
        <div *ngIf="dataSource.data?.length === 0" class="empty-state" fxLayout="column" fxLayoutAlign="center center">
            <mat-icon class="empty-icon">category</mat-icon>
            <h2>No Style Categories Yet</h2>
            <p>Get started by creating your first style category to organize your themes and styling options.</p>
            <button mat-raised-button color="primary" (click)="addStyleCategory()" class="empty-action-button">
                <mat-icon>add</mat-icon> Create First Category
            </button>
        </div>

        <!-- Categories Grid -->
        <div *ngIf="dataSource.data?.length > 0" class="categories-grid">
            <div *ngFor="let category of getFilteredCategories()" class="category-card-wrapper">
                <mat-card class="category-card" [class.has-children]="hasChildCategories(category)" (click)="editStyleCategory(category)">
                    <mat-card-header>
                        <div mat-card-avatar class="category-avatar">
                            <mat-icon [style.color]="getCategoryColor(category)">
                                {{ getCategoryIcon(category) }}
                            </mat-icon>
                        </div>
                        <mat-card-title class="category-title">{{ category.name || 'Untitled Category' }}</mat-card-title>
                        <mat-card-subtitle class="category-subtitle">
                            {{ category.description || 'No description provided' }}
                        </mat-card-subtitle>
                        <div class="card-actions">
                            <button mat-icon-button [matMenuTriggerFor]="menu" (click)="$event.stopPropagation()" 
                                    *ngIf="category.id != '00000000-0000-0000-0000-000000000000'">
                                <mat-icon>more_vert</mat-icon>
                            </button>
                            <mat-menu #menu="matMenu">
                                <button mat-menu-item (click)="editStyleCategory(category)">
                                    <mat-icon>edit</mat-icon> Edit Category
                                </button>
                                <button mat-menu-item (click)="duplicateCategory(category)">
                                    <mat-icon>content_copy</mat-icon> Duplicate
                                </button>
                            </mat-menu>
                        </div>
                    </mat-card-header>
                    
                    <mat-card-content>
                        <div class="category-stats" fxLayout="row" fxLayoutGap="16px">
                            <div class="stat-item" fxLayout="column" fxLayoutAlign="center center">
                                <span class="stat-number">{{ getStyleCount(category) }}</span>
                                <span class="stat-label">Styles</span>
                            </div>
                            <div class="stat-item" fxLayout="column" fxLayoutAlign="center center" *ngIf="hasChildCategories(category)">
                                <span class="stat-number">{{ getChildCategoryCount(category) }}</span>
                                <span class="stat-label">Subcategories</span>
                            </div>
                            <div class="stat-item" fxLayout="column" fxLayoutAlign="center center">
                                <mat-icon class="stat-icon" [style.color]="category.isRequired ? '#4caf50' : '#9e9e9e'">
                                    {{ category.isRequired ? 'check_circle' : 'radio_button_unchecked' }}
                                </mat-icon>
                                <span class="stat-label">{{ category.isRequired ? 'Required' : 'Optional' }}</span>
                            </div>
                        </div>

                        <!-- Quick Preview of Styles -->
                        <div *ngIf="getStyleCount(category) > 0" class="styles-preview">
                            <div class="preview-header">
                                <span class="preview-title">Style Preview</span>
                                <span class="view-all-link" (click)="editStyleCategory(category); $event.stopPropagation()">View All</span>
                            </div>
                            <div class="style-chips" fxLayout="row wrap" fxLayoutGap="4px">
                                <mat-chip-list class="preview-chips">
                                    <mat-chip *ngFor="let style of getPreviewStyles(category); let i = index" 
                                             [selectable]="false" class="style-preview-chip">
                                        {{ style.displayName }}
                                    </mat-chip>
                                    <mat-chip *ngIf="getStyleCount(category) > 3" class="more-chip">
                                        +{{ getStyleCount(category) - 3 }} more
                                    </mat-chip>
                                </mat-chip-list>
                            </div>
                        </div>
                    </mat-card-content>

                    <mat-card-actions align="end">
                        <button mat-button color="primary" (click)="editStyleCategory(category); $event.stopPropagation()">
                            <mat-icon>edit</mat-icon> Edit
                        </button>
                        <button mat-button (click)="viewCategoryDetails(category); $event.stopPropagation()" 
                                *ngIf="hasChildCategories(category)">
                            <mat-icon>visibility</mat-icon> View Details
                        </button>
                    </mat-card-actions>
                </mat-card>
            </div>
        </div>
    </div>

    <div *ngIf="selectedCategory" class="category" fxFlex="100">
        <button class="collapse" mat-mini-fab (click)="clearCategory()"
            matTooltip="Cancel">
            <mat-icon>clear</mat-icon>
        </button>

        <app-style-category-edit [category]="selectedCategory" [categories]="categories" [styles]="allStyles"
            (onSave)="saveCategory($event)"
            (onSaveStyles)="saveCategoryStyles($event)">
        </app-style-category-edit>

    </div>
</div>